import { render } from "./BtnPrimario.vue?vue&type=template&id=b6788618&scoped=true"
import script from "./BtnPrimario.vue?vue&type=script&lang=js"
export * from "./BtnPrimario.vue?vue&type=script&lang=js"

import "./BtnPrimario.vue?vue&type=style&index=0&id=b6788618&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6788618"]])

export default __exports__